import CompanyPerTypes from 'store/actionTypes/companyPerLink'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  companiesPersLinkManufacturer: [],
  companiesPersLinkSubcontractor: []
}

const companyPer = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case CompanyPerTypes.GET_COMPANY_PERS_LINK_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case CompanyPerTypes.GET_COMPANIES_PERS_LINK_MANUFACTURER_SUCCESS: {
      return {
        ...state,
        companiesPersLinkManufacturer: payload?.items || []
      }
    }
    case CompanyPerTypes.GET_COMPANIES_PERS_LINK_SUBCONTRACTOR_SUCCESS: {
      return {
        ...state,
        companiesPersLinkSubcontractor: payload?.items || []
      }
    }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default companyPer
